import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css'
import { locale, addLocale, PrimeReactProvider } from 'primereact/api';
import { createRoot } from "react-dom/client";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.css"; 
import "primeflex/primeflex.css"
import 'primeicons/primeicons.css';


addLocale('it', {
    addRule: "Aggiungi regola",
    removeRule: "Rimuovi regola",
    emptyMessage: "Nessun dato trovato",
    selectionMessage: '{0} elementi selezionati',
    emptySelectionMessage: 'Nessun elemento selezionato',
    firstDayOfWeek: 1,
    dayNames: ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato'],
    dayNamesShort: ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'],
    dayNamesMin: ['DO', 'LU', 'MA', 'ME', 'GI', 'VE', 'SA'],
    monthNames: ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'],
    monthNamesShort: ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'],
    today: 'Oggi',
    clear: 'Pulisci',
    equals: 'Uguale a',
    notEquals: "Diverso da",
    lt: "Minore di",
    lte: "Minore o uguale di",
    gt: "Maggiore di",
    gte: "Maggiore o uguale di",
    startsWith: "Inizia con",
    contains: "Contiene",
    notContains: "Non contiene",
    endsWith: "Termina con",
    dateIs: "Uguale a",
    dateIsNot: "Diverso da",
    dateBefore: "Minore di",
    dateAfter: "Maggiore di",
    apply: "Applica"

});

locale('it');

const container = document.getElementById("root");
const root = createRoot(container);

root.render(<PrimeReactProvider value={{locale: 'it'}}><App /></PrimeReactProvider>);
